const tableHelper={}

tableHelper.desc=function(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

tableHelper.stableSort=function(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

tableHelper.getSorting=function(order, orderBy) {
    return order === "desc"
        ? (a, b) => this.desc(a, b, orderBy)
        : (a, b) => -this.desc(a, b, orderBy);
}

tableHelper.handleRequestSort=function(order, orderBy, property) {
    const isDesc = this.state[orderBy] === property && this.state[order] === "desc";
    this.setState({
        [order]: isDesc ? "asc" : "desc",
        [orderBy]: property
    })
}

export default tableHelper